"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { testimonialsCardEntryPage } from "@/dataLayer/dataLayer";

export default function EditorialPageTracker() {
  const pathname = usePathname();
  const hasTracked = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (hasTracked.current === pathname) return;

    const raw = sessionStorage.getItem("tileCarousel");
    const storedData = raw ? (JSON.parse(raw) as { clicked: boolean; section: { title: string } }) : { clicked: false, section: { title: "" } };

    if (storedData.clicked) {
      testimonialsCardEntryPage({ tile_carousel_name: storedData?.section?.title, page_url: pathname });
      sessionStorage.removeItem("tileCarousel");
      hasTracked.current = pathname;
    }
  }, []);

  return null;
}
